import { render } from "./GstProfile.vue?vue&type=template&id=1f15cd9a"
import script from "./GstProfile.vue?vue&type=script&lang=js"
export * from "./GstProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__